export const STAFF = {
  newark: {
    'Larissa': { rate: .03 },
    'Leila': { rate: .03 },
    'Cristina': { rate: 0 },
    'Delson': { rate: 0 },
    'Bella': { rate: .03 },
    'Gabriel': { rate: 0 },
  },
  longbranch: {
    'Roberta': { rate: .05 },
    'Cristina': { rate: 0 },
    'Delson': { rate: 0 },
    'Bella': { rate: .03 },
    'Gabriel': { rate: 0 },
  }
}

export const LOCATIONS = { newark: 'Newark', longbranch: 'Long Branch' };
